import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 20px;
  height: 7px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "7px",
  "aria-label": "Scroll naar beneden"
}, /*#__PURE__*/React.createElement("g", {
  id: "02-pip-videodetail-mobile",
  transform: "translate(-178.000000, -615.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-/-more",
  transform: "translate(188.000000, 619.000000) rotate(180.000000) translate(-188.000000, -619.000000) translate(178.000000, 615.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.3693,6.51548 L9.8753,1.03348 C9.8343,1.01048 9.7903,0.99948 9.7473,0.99948 C9.7033,0.99948 9.6593,1.01048 9.6193,1.03348 L0.1253,6.51548 C0.0053,6.58348 -0.0357,6.73748 0.0333,6.85648 L0.5333,7.72248 C0.6023,7.84148 0.7553,7.88248 0.8753,7.81448 L9.7473,2.69148 L18.6193,7.81448 C18.7383,7.88248 18.8913,7.84148 18.9613,7.72248 L19.4613,6.85648 C19.5293,6.73748 19.4883,6.58348 19.3693,6.51548",
  id: "icon"
})))));